import React from 'react'

import template from './table-1.twig'

import parse from 'html-react-parser'

import {ButtonOptions, ContentOptions, HeadlineOptions, Offset} from '@miro-site/components_utils'
import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

export type listItem = {
  content?: ContentOptions
}

export type Item = {
  headline?: HeadlineOptions
  content?: ContentOptions
  headline2?: HeadlineOptions
  content2?: ContentOptions
  list: listItem[]
  button?: ButtonOptions
}

export interface Table1Props {
  offset?: Offset
  headline?: HeadlineOptions
  content?: ContentOptions
  items: Item[]
  children?: React.ReactNode
}

const Table1 = (props: Table1Props): React.ReactElement => {
  return <>{parse(template({...props, component_name: 'Table Section'}))}</>
}

export default Table1
